import React from 'react';
import { RefreshBtn, LoginBtn } from './showBtn'


/**
 * 
 * 错误页 500 502 
 * 
 */
const Error500 = () => {

  return (
    [
      <img className='fixed w-148px h-36px left-36px top-24px' src="https://p0.qhimg.com/t012e8c935bc13c337e.png" alt="logo" />,
      <div className="fixed left-1/2 top-1/2 min-w-680px transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center select-none">
        <>
          <p className="text-[#999] text-16px font-medium mt-66px mb-60px">
            (⊙o⊙)…N世界目前有点拥堵， 尝试登录获取新的席位吧~
          </p>
        </>
        <div>
          <RefreshBtn />
          <LoginBtn />
        </div>
      </div>
    ]
  );
}

export default Error500;